import { render, staticRenderFns } from "./dialog-table-proposal.vue?vue&type=template&id=d74a918a&scoped=true&"
import script from "./dialog-table-proposal.vue?vue&type=script&lang=js&"
export * from "./dialog-table-proposal.vue?vue&type=script&lang=js&"
import style0 from "./dialog-table-proposal.vue?vue&type=style&index=0&id=d74a918a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74a918a",
  null
  
)

export default component.exports